import {method} from '@/api/api';

export const actions = {
    getCategoryList({commit}, params) {
        method('tickets.categories.list', params).then(res => {
            commit('SET_CATEGORY_LIST', res.data)
        })
    }
};
